import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RecargaService } from '../../../../services/recarga.service';
import { AuthService } from '../../../../services/auth.service';
import { EnumPermissao } from '../../../../enums/permissoes.enum';
import { PermissaoService } from '../../../../services/permissao.service';
import { ToastrService } from 'ngx-toastr';
declare var bootstrap: any;

@Component({
  selector: 'app-modal-boas-vindas',
  templateUrl: './modal-boas-vindas.component.html',
  standalone: false
})
export class ModalBoasVindasComponent {
  @Output() fecharModalEvent = new EventEmitter<void>();
  @Input() mostrarModal: boolean = false;
  private modalInstance: any;
  public clienteEhPrePago: boolean = false;
  public EnumPermissao = EnumPermissao;

  constructor(
    private recargaService: RecargaService, 
    private authService: AuthService,
    private permissaoService: PermissaoService, 
    private toastr: ToastrService    
  ) {}

  ngAfterViewInit(): void {
    const modalElement = document.getElementById('modalBoasVindas');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement);
      if (this.mostrarModal) {        
        this.modalInstance.show();
      }
    } else {
      console.error('Elemento do modal de boas vindas não encontrado!');
    }
  }
  
  ngOnChanges(): void {
    if (this.modalInstance) {
      if (this.mostrarModal) {
        this.definirTextoModal();
        this.modalInstance.show();
      } else {
        this.modalInstance.hide();
      }
    }
  }

  fecharModal(): void {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
    this.fecharModalEvent.emit();
  }

  definirTextoModal(){
    const tipoCliente = this.authService.getTipoCliente();
    this.clienteEhPrePago = tipoCliente?.trim().toUpperCase() === 'PRE' || tipoCliente?.trim().toUpperCase() === 'PREPAGO-ONLINE';
  }

  navegarParaRecarga(event: Event): void{
    if(this.permissaoService.canFazerRecarga()){
      this.recargaService.navegarParaRecargas(event);
    }
    else {
      this.toastr.warning('Você não tem permissão para acessar recargas, solicite a um usuário master ou com a permissão habilitada'); 
      this.fecharModal();
    }
  }
}
